import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerServiceService } from '../customer-service.service';

@Component({
  selector: 'app-cancel-trip',
  templateUrl: './cancel-trip.component.html',
  styleUrls: ['./cancel-trip.component.css']
})
export class CancelTripComponent implements OnInit {
  modeldata: any;
  token: any;
  constructor(@Inject(MAT_DIALOG_DATA) data: any, private services: CustomerServiceService, private matdialogref: MatDialogRef<CancelTripComponent>
  ) {
    this.modeldata = data;

  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token")

  }
  tripCancel(modeldata: any) {
    // this.services.cancellationTrip(modeldata, this.token).subscribe((response: any) => {
    // })
  }
  GoToTrip() {
    this.matdialogref.close()
  }
}
